<div class="Flex--col" style="height:100%">

  <!--################ BEGIN Development version info ############### -->

  <div v-if="isDev" class="metropolatlas-dev-warning hide-on-print">
    ENTWICKLUNGSVERSION !!!
  </div>

  <!--
    <strong>ACHTUNG:</strong> Dies ist die <strong>Entwicklungsversion</strong> des Metropolatlas! Link bitte <strong>NICHT WEITERGEBEN</strong>! Zur offiziellen Version <a href="https://metropolatlas.digitale-mrn.de">hier entlang</a>.
    <div>Die Entwicklungsversion kann jederzeit technische und inhaltliche Fehler sowie anderweitige Elemente enthalten, die nicht für die öffentliche Präsentation gedacht und geeignet sind.</div>
    -->
  <!--################ END Development version info ############### -->

  <div class="Flex--row">

    <!--################### BEGIN Sidebar ################-->
    <Modal :autoCollapse="mobile" :allowOutsideInteraction="true" :show.sync="showSidebar" :class="getDynamicClass()">
      <div v-if="!mobile" class="App__Sidebar__MRN-Logo"><img src="img/logo_mrn_white.svg" /></div>
      <div v-if="mobile" class="App__Sidebar__MRN-Logo--mobile"><img src="img/logo_mrn_white_text_right.svg" /></div>
      <CmsMenu v-if="isDev" style="flex:1" href="https://metropolatlas.digitale-mrn.de/processwire/dashboards-dev/" @menuclick="onMenuClick" />
      <CmsMenu v-else style="flex:1" href="https://metropolatlas.digitale-mrn.de/processwire/dashboards/" @menuclick="onMenuClick" />
    </Modal>
    <!--################### END Sidebar ################-->

    <!-- ATTENTION: The overflow:hidden is a workaround to remove a horizontal scrollbar at the bottom
      of the page which appears for a currently unknown reason -->
    <div class="Flex--col" style="overflow:auto;overflow:hidden">

      <!--################### BEGIN Header ###################-->

      <Toolbar class="hide-on-print">
        <SmartButton class="Superbutton Input Button ToolbarItem" title="Menuleiste an/aus" v-model="showSidebar" :set="true" :unset="false">

          <img src="/tivigi/img/menu.svg" class="ButtonIcon" />
        </SmartButton>

        <portal-target name="AppHeader" style="display:contents">
          <!--
          This component can be located anwhere in your App.
          The slot content of the above portal component will be rendered here.
          -->
        </portal-target>

       
        <!--
        <router-link to="/cms/~dashboards~tutorial~" class="ToolbarItem" style="color:#000;">Hilfe</router-link>
       -->
        <FullscreenButton class="ToolbarItem Superbutton Button Input" title="Vollbild-Modus an/aus">
          <img src="/tivigi/img/maximize.svg" class="ButtonIcon" />
        </FullscreenButton>
      </Toolbar>

      <!--################### END Header ###################-->


      <!--################### BEGIN Main Content ################-->
      <router-view class="Flex--col" />
      <!--################### END Main Content ################-->

    </div>

    <Tooltip />
  </div>
</div>